
import styled from "styled-components";
import { Select,Col } from "antd";
import { Checkbox } from "antd";


export const Box = styled.div`
  background-color: rgba(0, 103, 120, 0.15);
  position: relative;
  padding : 20px 20px !important;
  box-shadow : 0px 10px 10px rgba(225, 225, 225, 0.5); 
  animation : slide-up 1s ease; 
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(-20px);
  }
  100% {
      opacity: 1;
      transform: translateY(0);
  }
  }
  @media (max-width: 991px) {
    margin-top : 30px;
    padding: 20px 20px !important;

    &:before {
      top: -20px;
      left: 50%;
      border: solid transparent;
      content: " ";
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-bottom-color: rgba(0, 103, 120, 0.15);
      border-width: 10px;
      margin-left: -10px;
    }
  }
`;

export const BottomWrapper = styled.div`
  padding-top:20px;
  display : flex;
  justify-content: space-between;
`;


export const CloseText = styled.button`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  background: none;
  border: none;
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  svg {
    font-size: ${props => props.theme.fontSize.quaternary};
  }
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const FilterCol = styled(Col)`
  vertical-align: text-bottom;
  padding-bottom:1.5625rem;
  max-height:6.25rem;
  float: ${props => props.float ? 'left' : 'none'} !important;
  display: inline-block !important;
  @media (max-width: 991px) {
    padding:10px 10px;
    display: inline-block !important;
    width: 100%;
  }
`;

export const FilterColAff = styled(Col)`
padding-bottom:1.5625rem;
`

export const TabTitles = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: ${props => props.theme.fontWeight.normal};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.primary};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color: ${props => props.theme.fontColors.headingColor};
  margin-bottom:0.3125rem;
  @media (max-width: 991px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: ${props => props.theme.lineHeight.secondary};
    margin-top:0.3125rem;
  }
`;

export const PoweredBy = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.quaternary};
  color: ${props => props.theme.fontColors.textColor};
  align-items: center;
  span {
    margin-right :10px;
    font-size:10px;
  }
`;

export const CheckBoxCustom = styled(Checkbox)`

`;

export const CheckBoxText =  styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.primary};
`;

export const FlexBox = styled.div`
  .ant-checkbox-wrapper{
    display :flex;
  }
  .ant-checkbox-inner{
    top:5px;
  }
`;